/* eslint-disable @typescript-eslint/naming-convention -- 常量枚举与存量 OPERATOR_TYPE 等命名风格一致 */
export const enum OPERATOR_TYPE {
  CMCC = 1,
  UNICOM = 2,
  TELCOM = 3,
}

export const enum CAPTCHA_LENGTH {
  TELCOM = 4,
  NORMAL = 6,
}

// 促销商品业务名称后缀
export const promotionNameSuffixMap = new Map([
  [OPERATOR_TYPE.CMCC, '随心玩促销包'], // 移动
  [OPERATOR_TYPE.TELCOM, '首月优惠畅玩包'], // 电信
  [OPERATOR_TYPE.UNICOM, '首月优惠畅玩包'], // 联通
]);

// 原价商品业务名称后缀
export const oriNameSuffixMap = new Map([
  [OPERATOR_TYPE.CMCC, '随心玩原价包'], // 移动
  [OPERATOR_TYPE.TELCOM, '免流畅玩包'], // 电信
  [OPERATOR_TYPE.UNICOM, '免流畅玩包'], // 联通
]);

export enum SUPPLIER_MAP {
  YZF = '302', // 电信翼支付供应商
}

/**
 * 短信验证码弹窗样式类型
 * STYLE_1: 标题展示订购信息，展示商品icon，展示确认按钮
 * STYLE_2: 标题展示福利引导，展示商品icon，展示确认按钮
 * STYLE_3: 标题展示福利引导，展示套餐信息PackageInfo，展示确认按钮
 */
export enum SMS_MODAL_STYLE {
  STYLE_1 = 'cmcc',
  STYLE_2 = 'dx',
  STYLE_3 = 'dxyzf',
}

/* eslint-enable @typescript-eslint/naming-convention */

export interface PackageInfoItem {
  label: string;
  value: string;
}

/**
 * 站内协议内容条目
 * - id：唯一标识，富文本里用 href="#agreement-{id}" 关联
 * - title：协议弹窗标题，会自动加书名号展示
 * - content：协议正文（富文本）
 */
export interface AgreementContentItem {
  id: string;
  title: string;
  content: string;
}

/**
 * 订购弹窗协议合规配置（作用于所有订购短信弹窗，全局单例）
 * 由 SMSAgreementConfig 组件挂载时注入 useGlobalStore
 *
 * 富文本 displayText 中 <a> 标签的 href 规则：
 *   - "#agreement-{id}" → 弹站内协议详情（对应 agreements 数组中匹配 id 的条目）
 *   - "https://..."     → 新标签页打开外链
 *   - 其它（含空）      → 阻止默认跳转，无操作
 */
export interface AgreementConfig {
  displayText: string;
  agreements: AgreementContentItem[];
  agreementVersion: string;
  defaultChecked: boolean;
  enableReconfirm: boolean;
  reconfirmTitle?: string;
  reconfirmConfirmText?: string;
}

/**
 * 订购弹窗协议合规配置-默认值（单一数据源）
 * 同时被 SMSAgreementConfig 组件 dataForm 复用，避免双份硬编码
 */
export const DEFAULT_AGREEMENT_CONFIG: AgreementConfig = {
  displayText:
    '我已阅读并同意<a href="#agreement-privacy">《尊享会员(24期)个人信息保护政策》</a>、<a href="#agreement-order">《尊享会员(24期)订购协议》</a>',
  agreements: [
    {
      id: 'privacy',
      title: '尊享会员(24期)个人信息保护政策',
      content: '',
    },
    {
      id: 'order',
      title: '尊享会员(24期)订购协议',
      content: '',
    },
  ],
  agreementVersion: '1.0',
  defaultChecked: false,
  enableReconfirm: true,
  reconfirmTitle: '温馨提示',
  reconfirmConfirmText: '同意并继续',
};

export const DEFAULT_PACKAGE_INFO_LIST: PackageInfoItem[] = [
  { label: '业务名称', value: '尊享会员(24期)' },
  { label: '资费标准', value: '14.9元/月' },
  { label: '适用范围', value: '仅支持中国电信移动用户订购' },
  { label: '销售渠道', value: '线下及线上渠道' },
  { label: '上下线时间', value: '2023-08-11至2027-07-31' },
  { label: '有效期限', value: '24个自然月 到期自动失效' },
  { label: '退订方式', value: '线下营业厅、拨打10000号或95106' },
  { label: '在网要求', value: '无' },
  { label: '违约责任', value: '退订不收违约金' },
];
